<div class="section guarantee" *ngIf="garanties$ | async as garanties">
  <div class="container-xl">
    <div class="section-title">
      <h2 class="title">{{ garanties?.title }}</h2>
    </div>
    <div class="section-content">
      <div
        fxLayout="row"
        fxLayout.lt-md="row wrap"
        fxLayout.lt-sm="column"
        fxLayoutAlign="space-between center"
        fxLayoutAlign.lt-md="space-around center"
        fxLayoutGap="30px"
        fxLayoutGap.lt-md="10px"
      >
        <div class="circle-wrapper" ngClass.lt-md="mb-4" *ngFor="let item of garanties?.garanties; trackBy: trackByFn">
          <div class="circle">
            <h3 class="circle-title">{{ item.count }}{{ item.unit }}</h3>
            <p class="circle-description">{{ item?.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
